export function formatTemplate(taskId) {
    return (template) => {
        const { attachmentId: templateId } = template;
        return {
            template_id: templateId,
            task_id: taskId,
        };
    };
}
